<div class="ecb-admin-page">
  <aside class="portal-sidebar">
    <a routerLink="/" class="ecb-logo mb-4"><span class="ecb-logo-mark"> <img src="assets/images/logo/logo-white.webp"
          alt="ECB Training" class="ecb-web-header-logo"></span></a>
    <a routerLink="/admin/dashboard" routerLinkActive="active"><i class="fa fa-home"></i>Dashboard</a>
    <a routerLink="/admin/courses" routerLinkActive="active"><i class="fa fa-graduation-cap"></i>Long Courses</a>
    <a routerLink="/admin/shortCourses"><i class="fa fa-book"></i>Short Courses</a>
    <a routerLink="/admin/vocPublicCourses"><i class="fa fa-certificate"></i>VOC Courses</a>
    <a routerLink="/admin/tags" routerLinkActive="active"><i class="fa fa-tags"></i>Qualifications</a>

    <a routerLink="/admin/orders" routerLinkActive="active"><i class="fa fa-shopping-cart"></i>Long Orders</a>
    <a routerLink="/admin/vocRequests"><i class="fa fa-shopping-bag"></i>VOC Orders</a>
    <a routerLink="/admin/shortCourseOrders"><i class="fa fa-cart-plus"></i>Short Course Orders</a>
    <a routerLink="/admin/enquiriesList"><i class="fa fa-comments"></i>General Enquiries & Bookings</a>
    <a routerLink="/admin/bookingsList"><i class="fa fa-comments"></i>Corporate Bookings</a>
    <a routerLink="/admin/manualSync"><i class="fa fa-refresh"></i>Manual Sync</a>
    <a style="color:rgba(var(--ecb-accent-rgb), 1)" routerLink="/course-qualifications"><i
        class="fa fa-globe"></i>Public Courses</a>

    <div class="portal-sidebar-divider"></div>

    <a routerLink="/admin/customers" routerLinkActive="active"><i class="fa fa-users"></i>Customers</a>
    <a routerLink="/admin/admin-users" routerLinkActive="active"><i class="fa fa-user-secret"></i>Admins</a>
  </aside>
  <main class="portal-content"><router-outlet></router-outlet></main>
</div>